// extracted by mini-css-extract-plugin
module.exports = {"root":"text-area_root__3II1_"};